<template>
  <div class="MarkingList">
    <AppHeader content="教学数据 | 未听懂报告"></AppHeader>
    <div class="titleBox">
      <b class="seriesBox">{{ detailMarkInfo.classSubjectName }}</b>
      <div>
        <b>第{{ detailMarkInfo.sortNumber }}课：</b
        >{{ detailMarkInfo.lessonName }}
      </div>
    </div>
    <AppBox id="appBox" class="appBox">
      <XTable
        :api="getDataMarkInfoList"
        :state="dataMarkInfoList"
        :columns="columns"
        :loading="dataMarkInfoListLoading"
        :tableSize="tableSize"
        :layout="layout"
        :maxHeight="maxHeight"
        :firstColumn="firstColumn"
      ></XTable>
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import XTable from "@/components/XTable/index.vue";
import { mapActions, mapState } from "vuex";
import { MODULE_TYPE } from "@/utils/constants";

export default {
  name: "MarkingList",
  components: { XTable, AppBox, AppHeader },
  data() {
    const columns = [
      {
        prop: "rootId",
        label: "内容序号",
      },
      {
        label: "内容类型",
        render(h, scope) {
          return (
            <div>
              <span>{MODULE_TYPE[scope.row.contentType]}</span>
            </div>
          );
        },
      },
      {
        label: "学习人数",
        render(h, scope) {
          return (
            <div>
              <span>{(scope.row && scope.row.learningCount) || 0}</span>
            </div>
          );
        },
      },
      {
        label: "标记人数",
        render(h, scope) {
          return (
            <div>
              <span>{Math.round(scope.row && scope.row.markCount) || 0}</span>
            </div>
          );
        },
      },
      {
        label: "标记率",
        render(h, scope) {
          const markRateCount = scope.row && scope.row.markRate;
          return (
            <div>
              <span>
                {markRateCount !== null ? `${markRateCount}` * 100 + "%" : "-"}
              </span>
            </div>
          );
        },
      },
    ];
    return {
      tableSize: "small",
      layout: "",
      firstColumn: true,
      maxHeight: null,
      columns: [...columns],
      detailMarkInfo: {},
    };
  },
  computed: {
    ...mapState("dataCenter", ["dataMarkInfoList", "dataMarkInfoListLoading"]),
  },
  mounted() {
    this.detailMarkInfo = JSON.parse(localStorage.getItem("detailMarkInfo"));
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize); // 移除resize事件监听
  },
  methods: {
    ...mapActions("dataCenter", ["getDataMarkInfo"]),
    async getDataMarkInfoList() {
      await this.getDataMarkInfo({
        id: this.$route.params.id,
      });
    },
    handleResize() {
      this.$nextTick(() => {
        const el = document.getElementById("appBox");
        this.maxHeight = el.offsetHeight - el.offsetHeight * 0.2;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.MarkingList {
  .titleBox {
    background: #ffffff;
    margin-bottom: 5px;
    padding: 20px;
    display: flex;
    align-items: center;

    .seriesBox {
      margin-right: 80px;
    }
  }

  .appBox {
    height: calc(100vh - 220px);
  }
}
</style>
